"use client";

import { Fragment, ReactNode, useEffect } from "react";
import { redirect } from "next/navigation";

import { GoogleTagManagerInitiator } from "@/components/GoogleTagManagerInitiator";
import { Header } from "@/components/Header";

import { usePrefetchRouter } from "@/hooks/navigation/usePrefetchRouter";
import { getCookie } from "@/services/CookiesService";

import { PATHS } from "@/internals/constants/paths";
import { getQrSlugs } from "@/utils/qrSlug";

import { getSiteInfo } from "@/sites";

import { DOWNLOAD_QR_COOKIE } from "@/containers/AuthContainer/types";

import "./styles.scss";

export default function EditorLayout({ children }: { children: ReactNode }) {
  const { downloadQRRedirectionPath } = getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN!);

  useEffect(() => {
    const downloadQR = getCookie(DOWNLOAD_QR_COOKIE);
    if (downloadQR && downloadQRRedirectionPath) {
      redirect(downloadQRRedirectionPath);
    }
  }, [downloadQRRedirectionPath]);

  const getDynamicQrSlugRoutes = () => {
    const qrSlugs = getQrSlugs();
    const routes = qrSlugs.map((slug: string) => {
      return `${PATHS.QR_EDITOR}/${slug}`;
    });
    return routes;
  };
  usePrefetchRouter(getDynamicQrSlugRoutes());

  return (
    <Fragment>
      <GoogleTagManagerInitiator />
      <Header noNav />
      {children}
    </Fragment>
  );
}
